<template>
  <BasePopup
    :visible="v3PopupState.bagPopupState"
    :mask-closable="true"
    :show-close-btn="true"
    :show-confirm-btn="false"
    popup-class="bag-popup"
    @close="handleClose"
  >
    <div class="v3-popup-content-title"></div>
    <div class="v3-popup-content-content">
      <div class="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>獎勵名稱</th>
              <th>獲得時間</th>
              <th>當前狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in awardLogList" :key="index">
              <td>{{ getRewardName(item) }}</td>
              <td>{{ item.rewardTime }}</td>
              <td>
                <div
                  v-if="getRewardStatusInfo(item).canViewCode"
                  class="view-code-btn"
                  @click="viewCode(item)"
                >
                  {{ getRewardStatusInfo(item).text }}
                </div>
                <span v-else>{{ getRewardStatusInfo(item).text }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="bag-popup-tips">※版本更新後，請返回活動頁領取禮包碼</p>
  </BasePopup>
</template>

<script setup>
import { inject, reactive, watch } from "vue";
import { getRewardNameByConfigId } from "@/config/rewards";
import { point } from "@/utils";
import useGetAward from "@/hooks/useGetAward";
import BasePopup from "./BasePopup.vue";

const showCurErrorTips = inject("showCurErrorTips", () => {});
const showTipMessage = inject("showTipMessage", () => {});
const v3PopupState = inject("v3PopupState", reactive({}));
const lotteryAndTaskState = inject("lotteryAndTaskState", reactive({}));

const {
  awardLogList,
  initAwardList,
  resetAwardList,
  getVirtualAward,
  fillPhysicalAward,
  viewCode,
  getRewardStatus,
} = useGetAward(showTipMessage, showCurErrorTips);

const initActivity = inject("initActivity", async () => {});

const getVirtualAwardFn = async () => {
  const res = await getVirtualAward();
  if (res) {
    lotteryAndTaskState.canClaimVirtualReward = false;
    await initActivity();
  }
};
const getPhysicalAwardFn = async () => {
  await fillPhysicalAward();
  await initActivity();
};

// 关闭弹窗
const handleClose = () => {
  v3PopupState.bagPopupState = false;
};

// 获取奖励名称
const getRewardName = (item) => {
  // 使用 rewardConfigId 从配置中获取奖励名称
  return getRewardNameByConfigId(item.rewardConfigId);
};

// 获取奖励状态信息
const getRewardStatusInfo = (item) => {
  const statusInfo = getRewardStatus(item);

  // 如果是"查看禮包碼"状态，添加特殊样式标记
  if (statusInfo.text === '查看禮包碼>>') {
    return {
      ...statusInfo,
      isViewCode: true
    };
  }

  return statusInfo;
};

watch(
  () => v3PopupState.bagPopupState,
  async (value) => {
    if (value) {
      // 打点上报：背包弹窗展示
      point({
        eventName: 'show_popup',
        eventType: '我的背包弹窗'
      });
      await initAwardList();
    } else {
      resetAwardList();
    }
  },
  { immediate: false }
);
</script>

<style scoped lang="less">
.view-code-btn {
  cursor: pointer;
  text-decoration: underline;
  white-space: nowrap;
  font-size: 30px;
  color: #ee9553;
}
</style>
